import React, { useState } from "react";
import FilterDropDown from "./FilterDropDown";

const Filters = ({ genres, authors, filterBooksByGenre, filterBooksByAuthor, resetAllFilters, resetFilters }) => {
    const [isFilterGenreOpen, setIsFilterGenreOpen] = useState(false);
    const [isFilterAuthorOpen, setIsFilterAuthorOpen] = useState(false);

    return (
        <div className="flex items-center gap-2">
            <button
                type="button"
                onClick={resetAllFilters}
                className="text-sm text-warm-500 hover:text-warm-700 font-medium px-3 py-1.5 border border-warm-200 rounded-lg hover:bg-warm-50 transition-colors"
            >
                Clear filters
            </button>

            <div className="relative">
                <button
                    type="button"
                    onClick={() => { setIsFilterGenreOpen(v => !v); setIsFilterAuthorOpen(false); }}
                    className="flex items-center gap-1.5 text-sm font-medium text-warm-700 bg-white border border-warm-200 hover:bg-warm-50 px-3 py-1.5 rounded-lg transition-colors"
                >
                    Genre
                    <svg className={`w-3 h-3 transition-transform ${isFilterGenreOpen ? 'rotate-180' : ''}`} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
                        <path strokeLinecap="round" strokeLinejoin="round" d="m19 9-7 7-7-7" />
                    </svg>
                </button>
                <FilterDropDown
                    isFilterOpen={isFilterGenreOpen}
                    filters={genres}
                    filterBooks={filterBooksByGenre}
                    resetFilters={resetFilters}
                />
            </div>

            <div className="relative">
                <button
                    type="button"
                    onClick={() => { setIsFilterAuthorOpen(v => !v); setIsFilterGenreOpen(false); }}
                    className="flex items-center gap-1.5 text-sm font-medium text-warm-700 bg-white border border-warm-200 hover:bg-warm-50 px-3 py-1.5 rounded-lg transition-colors"
                >
                    Author
                    <svg className={`w-3 h-3 transition-transform ${isFilterAuthorOpen ? 'rotate-180' : ''}`} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
                        <path strokeLinecap="round" strokeLinejoin="round" d="m19 9-7 7-7-7" />
                    </svg>
                </button>
                <FilterDropDown
                    isFilterOpen={isFilterAuthorOpen}
                    filters={authors}
                    filterBooks={filterBooksByAuthor}
                    resetFilters={resetFilters}
                />
            </div>
        </div>
    );
};

export default Filters;
